// extracted by mini-css-extract-plugin
export default {"total":"Layout_total__DHN9Y","layout":"Layout_layout__UnRbg","backgroundMap":"Layout_backgroundMap__kOB4g"};